/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'
import { useRecoilState } from 'recoil'
import { useWindowWidth } from '@packages/util'

import currentQuestionNumberAtom from 'store/currentQuestionNumber'
import currentPageAtom from 'store/currentPage'
import useExamInform from '@hooks/useExamInform'
import { useQuestionPerPageStore } from 'store/questionPerPage'

type QuestionInformation = {
  choice: string
  wrong: string[]
}

export type InformationOfQuestionNumber = { [key: string]: QuestionInformation }

const UseCurrentQuestion = (isDelivery?: boolean) => {
  const [isInitial, setIsInitial] = useState(true)
  const [currentPage, setCurrentPage] = useRecoilState(currentPageAtom)
  const [bottomNumber, setBottomNumber] = useState('01')
  const [currentQuestionNumber, setCurrentQuestionNumber] =
    useRecoilState(currentQuestionNumberAtom)
  const [totalPage, setTotalPage] = useState(0)
  const { questionPerPage, setQuestionPerPage } = useQuestionPerPageStore()

  const { currentQuestionGroup } = useExamInform(isDelivery)

  const countQuestions = currentQuestionGroup?.questions?.length || 80

  const windowWidth = useWindowWidth()

  useEffect(() => {
    setIsInitial(false)
  }, [])

  useEffect(() => {
    const frontZeroNumber = String(currentPage).padStart(2, '0')
    setBottomNumber(frontZeroNumber)
  }, [currentPage])

  useEffect(() => {
    const page = Math.ceil(currentQuestionNumber / questionPerPage)
    setCurrentPage(page)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionPerPage, setCurrentPage])

  useEffect(() => {
    const currentQuestionNumber = questionPerPage * (currentPage - 1) + 1
    setCurrentQuestionNumber(currentQuestionNumber)
  }, [questionPerPage, currentPage, setCurrentQuestionNumber])

  useEffect(() => {
    setTotalPage(Math.ceil(countQuestions / questionPerPage))
  }, [questionPerPage])

  useEffect(() => {
    if (windowWidth < 640) {
      setQuestionPerPage(1)
    }
  }, [windowWidth, setQuestionPerPage])

  const isQuestionInCurrentPage = (questionNumber: number) => {
    const firstQuestionInPage = questionPerPage * (currentPage - 1) + 1
    return (
      firstQuestionInPage <= questionNumber &&
      firstQuestionInPage + questionPerPage - 1 >= questionNumber
    )
  }

  const goToQuestion = (num: number) => {
    const page = Math.ceil(num / questionPerPage)
    setCurrentPage(page)
  }
  const nextPage = () => {
    setCurrentPage((page: number) => page + 1)
  }

  const prevPage = () => {
    setCurrentPage((page: number) => page - 1)
  }
  return {
    currentPage: isInitial === true ? 1 : currentPage,
    setCurrentPage,
    totalPage,
    currentQuestionNumber,
    setCurrentQuestionNumber,
    questionPerPage: isInitial === true ? 1 : questionPerPage,
    setQuestionPerPage,
    nextPage,
    prevPage,
    isQuestionInCurrentPage,
    goToQuestion,
    bottomNumber,
  }
}

export default UseCurrentQuestion
